import * as React from 'react';
import { ThemeProvider as EmotionThemeProvider, Global } from '@emotion/react';

import { lightTheme, darkTheme } from './index';
import Header from '../Header';
import { baseStyles, mdxStyles } from '../styles/GlobalStyles';
import { styles } from '../../custom/styles/styles';

/**
 * ThemeProvider Component
 * Manages light/dark theme switching with CSS custom properties
 * and Emotion theme context
 */
class ThemeProvider extends React.Component {
  state = {
    isDarkThemeActive: false,
  };

  componentDidMount() {
    this.retrieveActiveTheme();
  }

  componentDidUpdate(prevProps, prevState) {
    // Update data-theme attribute when theme changes
    if (prevState.isDarkThemeActive !== this.state.isDarkThemeActive) {
      this.updateDocumentTheme();
    }
  }

  retrieveActiveTheme = () => {
    const isDarkThemeActive = JSON.parse(window.localStorage.getItem('isDarkThemeActive'));
    this.setState({ isDarkThemeActive }, () => {
      this.updateDocumentTheme();
    });
  };

  updateDocumentTheme = () => {
    // Apply data-theme attribute for CSS custom properties
    if (typeof document !== 'undefined') {
      const theme = this.state.isDarkThemeActive ? 'dark' : 'light';
      document.documentElement.setAttribute('data-theme', theme);
      document.body.setAttribute('data-theme', theme);
    }
  };

  toggleActiveTheme = () => {
    this.setState(prevState => ({ isDarkThemeActive: !prevState.isDarkThemeActive }));
    window.localStorage.setItem('isDarkThemeActive', JSON.stringify(!this.state.isDarkThemeActive));
  };

  render() {
    const { children, location } = this.props;
    const { isDarkThemeActive } = this.state;
    const currentActiveTheme = isDarkThemeActive ? darkTheme : lightTheme;

    return (
      <div data-theme={isDarkThemeActive ? 'dark' : 'light'}>
        <Global styles={[baseStyles, mdxStyles,...styles]} />
        <Header
          location={location}
          isDarkThemeActive={isDarkThemeActive}
          toggleActiveTheme={this.toggleActiveTheme}
        />
        <EmotionThemeProvider theme={currentActiveTheme}>{children}</EmotionThemeProvider>
      </div>
    );
  }
}

export default ThemeProvider;
